import React from "react";

/**
 * KPICard - Tarjeta de indicador numérico con variación y color por tendencia.
 *
 * Props:
 * - title: string - Etiqueta del indicador
 * - value: string|number - Valor principal formateado
 * - variation: string|number|undefined - Texto de variación (ej: "+12.5%", "N/A")
 * - trend: 'up'|'down'|'neutral'|undefined - Dirección de tendencia para color
 * - icon: React.ReactNode (optional) - Ícono decorativo
 * - loading: boolean (optional) - Muestra skeleton si está cargando
 */
export function KPICard({ title, value, variation, trend, icon, loading }) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
        <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-1/3"></div>
      </div>
    );
  }

  const trendColor =
    trend === "up"
      ? "text-green-600"
      : trend === "down"
      ? "text-red-600"
      : "text-gray-500";

  const trendIcon =
    trend === "up"
      ? "↑"
      : trend === "down"
      ? "↓"
      : "";

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 flex flex-col justify-between min-h-[120px]">
      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-500 font-medium">{title}</p>
        {icon && <span className="text-gray-400">{icon}</span>}
      </div>
      <p className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mt-1 break-all leading-tight" title={String(value)}>
        {value}
      </p>
      {variation !== undefined && variation !== null && (
        <p className={`text-sm mt-1 font-medium ${trendColor}`}>
          {trendIcon && <span className="mr-1">{trendIcon}</span>}
          {variation}
        </p>
      )}
    </div>
  );
}

export default KPICard;
